module.exports = __webpack_public_path__ + "img/6.cab1c218.png";